import { createAsyncThunk } from "@reduxjs/toolkit";
import { RestS } from "../../rest/rest-service";

interface FetchAgencyClientsOpts {
  preSelectClientCompanyId?: string;
}

export const fetchAgencyClients = createAsyncThunk<
  { clients: any[]; preSelectClientCompanyId?: string },
  FetchAgencyClientsOpts
>(
  "agencyConfig/fetchClients",
  async ({ preSelectClientCompanyId = null }, { rejectWithValue }) => {
    try {
      const response = await RestS.getConnectedCompanies();
      return {
        clients: response,
        preSelectClientCompanyId,
      };
    } catch (error) {
      console.error("Error fetching agency clients:", error);
      return rejectWithValue("Failed to fetch agency clients");
    }
  }
);
